/*rutas del layout y dashboard*/
function children (path, folder, view, name) {
  //debugger;
  return {
    name: name || view,
    path,
    component: (resolve) => import(
      `@/${folder}/${view}.vue`
    ).then(resolve)
  }
}
import dash from './paths_display_dash.js' 
import DisplayDash from './paths_display_view.js' 
import DisplayFom from './paths_display_form.js'
import DisplaySetting from './paths_display_setting.js'

let rutas_dash=dash.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_DisplayDash=DisplayDash.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_DisplayFom=DisplayFom.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_DisplaySetting=DisplaySetting.map(r => children(r.path, r.folder, r.view, r.name));

let rutas_children= [];
rutas_children=rutas_children.concat(rutas_dash);
rutas_children=rutas_children.concat(rutas_DisplayDash);
rutas_children=rutas_children.concat(rutas_DisplayFom);
rutas_children=rutas_children.concat(rutas_DisplaySetting);
export default [
  {
    path: '/',
    view: 'DisplayLayout',
    folder: 'Layouts/display',
    meta: {requiresAuth: true},
    children: rutas_children
  }
];